<div class="live-stream">
	<form #formRef="ngForm" class="create-live-stream" name="form" (submit)="createLiveStream()" novalidate>
		<bb-form-element [form]="form" label="{{'TITLE' | translate}}">
			<input [(ngModel)]="title" type="text" name="title" />
		</bb-form-element>
		<bb-form-element [form]="form" label="{{'STREAM_NAME' | translate}}" infoMessage="{{ 'HELP.CORRECT_STREAM_NAME_FORMAT' | translate }}"
			name="stream-name" (change)="streamNameChanged()" (blur)="streamNameChanged()">
		<input [(ngModel)]="streamName" type="text" name="stream-name" />
		</bb-form-element>
		
		<bb-form-element [form]="form" label="{{'STREAM_TYPE' | translate}}">
			<div class="stream-type-option">
				<bb-radio [name]="'stream-type-video'" [(ngModel)]="streamType" [val]="'video'"
					[label]="'VIDEO' | translate" (click)="streamTypeChanged()"></bb-radio>
			</div>
			<div class="stream-type-option">
				<bb-radio [name]="'stream-type-audio'" [(ngModel)]="streamType" [val]="'audio'"
					[label]="'AUDIO' | translate" (click)="streamTypeChanged()"></bb-radio>
			</div>
		</bb-form-element>

		<bb-form-element [form]="form" label="{{'INGEST_TYPE' | translate}}">
			<div class="ingest-type-option" *ngIf="streamType==='video'">
				<bb-radio [name]="'ingest-type-rtmp'" [(ngModel)]="ingestType" [val]="'rtmp'"
					[label]="'INGEST_TYPE_RTMP' | translate"></bb-radio>
			</div>
			<div class="ingest-type-option" *ngIf="streamType==='video'">
				<bb-radio [name]="'ingest-type-webdav'" [(ngModel)]="ingestType" [val]="'webdav'"
					[label]="'INGEST_TYPE_WEBDAV' | translate"></bb-radio>
			</div>
			<div class="ingest-type-option" *ngIf="streamType==='audio'">
				<bb-radio [name]="'ingest-type-icecast'" [(ngModel)]="ingestType" [val]="'icecast'"
					[label]="'INGEST_TYPE_ICECAST' | translate"></bb-radio>
			</div>
		</bb-form-element>

		<bb-form-element [form]="form" label="{{'INGEST_VARIANT' | translate}}" *ngIf="ingestType==='rtmp'">
			<div class="stream-type-option">
				<bb-radio [name]="'ingest-variant-simple'" [(ngModel)]="ingestVariant" [val]="'simple'"
					[label]="'INGEST_VARIANT_SIMPLE' | translate"></bb-radio>
			</div>
			<div class="stream-type-option">
				<bb-radio [name]="'ingest-variant-multi'" [(ngModel)]="ingestVariant" [val]="'multi'"
					[label]="'INGEST_VARIANT_MULTI' | translate"></bb-radio>
			</div>
		</bb-form-element>
					
		<div class="input">
			<button [disabled]="!putRight" type="submit" class="button submit">
				<i class="fa fa-rocket" [ngClass]="{disabled: !putRight}"></i>
				{{ 'CREATE_LIVE_STREAM' | translate }}
			</button>
		</div>

	</form>

</div>
